import * as React from "react";
function SvgCircleInfo(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={16}
        cy={16}
        r={15}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path d="M17.39 21.64a7.88 7.88 0 01-.72.84 7.27 7.27 0 01-.88.76 5.36 5.36 0 01-.92.55 2 2 0 01-.79.21q-.43 0-.54-.27a1.68 1.68 0 01-.11-.62 1.13 1.13 0 010-.2.3.3 0 010-.17L15 15.38a.33.33 0 000-.15c0-.13-.05-.2-.16-.2s-.62.33-1.27 1l-.28-.53a6.43 6.43 0 01.73-.82 9 9 0 01.89-.75 6.06 6.06 0 01.92-.56 1.91 1.91 0 01.81-.22.52.52 0 01.45.2 1.27 1.27 0 01.15.72v.17a1 1 0 010 .2l-1.44 6.23c0 .18-.07.36-.11.53a2.38 2.38 0 00-.05.5q0 .42.21.42t1.27-1zm-.1-10.79Q16 10.85 16 9.41A1.24 1.24 0 0117.39 8q1.33 0 1.33 1.4a1.27 1.27 0 01-1.43 1.44z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleInfo);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
